export const subscriptionManagementApiUrls = {
  getPurchaseHistory: '/api/v1/subscriptions/purchase-history',
  getPaymentCards: '/api/v1/subscriptions/payment-cards',
  savePaymentCard: '/api/v1/subscriptions/payment-cards',
  deletePaymentCard: '/api/v1/subscriptions/payment-cards',
  setDefaultPaymentCard: '/api/v1/subscriptions/payment-cards/set-default',
};
